let baseurl;
// baseurl = 'http://192.168.2.85:9001/vegetable-shop-api';
// baseurl = 'http://192.168.1.201:8096/vegetable-shop-api';
// baseurl = "http://run.buybal.com/vegetable-shop-api"
// baseurl="http://192.168.2.7:9001/vegetable-shop-api"
baseurl="https://yyg.chinanums.com/api"
let wsUrl;
// wsUrl = 'ws://run.buybal.com/buybalOrder/ws/';
wsUrl = 'wss://mp.chinanums.com/buybalOrder/ws/';
export { baseurl, wsUrl };




// WEBPACK FOOTER //
// ./src/base.js